import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      alignItems: 'center'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
